module.exports = __webpack_public_path__ + "media/application/images/ui/icon-chevron-white-0c91559edc268fd1f5f33fc674e8c17c.png";